import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataToSendDichiarazione } from '../../dischiarazione.models';

@Component({
    selector: 'app-dettagli-contributi-versati-da-f24',
    templateUrl: './dettagli-contributi-versati-da-f24.component.html',
    styleUrls: ['./dettagli-contributi-versati-da-f24.component.scss'],
})
export class DettagliContributiVersatiDaF24Component implements OnInit, OnDestroy {
    constructor(
        public dialogRef: MatDialogRef<DettagliContributiVersatiDaF24Component>,
        @Inject(MAT_DIALOG_DATA)
        public dettagliContributiVersati: { dataToSendDichiarazione: DataToSendDichiarazione }
    ) {}

    ngOnInit() {}

    ngOnDestroy(): void {}
}
